import { t } from '@/plugins/i18n';
import { unauthorizedRoutes } from './routes/unauthorizedRoutes';
import type { RouteDefinition } from './types';
import { RouteName } from './constants/routeNames';
import { authorizedRoutes } from './routes/authorizedRoutes';

export const appRoutes: RouteDefinition[] = [
  {
    path: '',
    name: 'UnauthorizedLayout',
    component: () => import('../layouts/UnauthorizedLayout.vue'),
    children: unauthorizedRoutes
  },
  {
    path: '',
    name: 'DefaultLayout',
    component: () => import('../layouts/DefaultLayout.vue'),
    children: authorizedRoutes(t)
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: RouteName.Dashboard }
  }
];
